import {observer} from "mobx-react";
import {JSX, useState} from "react";
import {RegistrationNotificationDto, RegistrationNotificationDtoNotificationTypeEnum} from "../../../../../api";

import "./RegistrationNotificationBar.scss"
import {
    ModalStore,
    registrationNotificationStore,
} from "../../../../../store";
import QRCode from "react-qr-code";
import {Modal} from "../../../../ui";

function getIcon(dto: RegistrationNotificationDto): string | undefined {
    if (dto.code) {
        return 'person_search'
    }
    switch (dto.notificationType) {
        case RegistrationNotificationDtoNotificationTypeEnum.INFO: return 'info'
        case RegistrationNotificationDtoNotificationTypeEnum.SUCCESS: return 'check_circle'
        case RegistrationNotificationDtoNotificationTypeEnum.ERROR: return 'cancel'
        case RegistrationNotificationDtoNotificationTypeEnum.WARNING: return 'warning'
        case RegistrationNotificationDtoNotificationTypeEnum.VERIMI_LOCAL_IDENT_WEB_URL: return 'info'
        case RegistrationNotificationDtoNotificationTypeEnum.VERIMI_LOCAL_IDENT_IOS_CODE: return 'info'
    }
    return undefined
}

function RegistrationNotification({
    dto,
    ActionButton
                                  }: {
    dto: RegistrationNotificationDto,
    ActionButton?: () => JSX.Element
}) {
    const icon = getIcon(dto)
    const [modalStore] = useState(new ModalStore())

    function openQrDialog() {
        modalStore.open()
    }

    return <>{icon ? <>
        <div className={`registration-notification ${dto.code ? dto.code[0] : dto.notificationType}`}>
            <div className={"icon"}>
                <span className="material-symbols-outlined">{icon}</span>

            </div>
            {dto.notificationType === RegistrationNotificationDtoNotificationTypeEnum.VERIMI_LOCAL_IDENT_IOS_CODE ||
                dto.notificationType === RegistrationNotificationDtoNotificationTypeEnum.VERIMI_LOCAL_IDENT_WEB_URL
                ? <button className={'button'} onClick={() => openQrDialog()}>QR Code zum Dokumente signieren</button>
                : <div className={"notification-message"} title={dto.message}>{dto.message}</div>
            }

            {ActionButton ? <div className={"action"}><ActionButton /></div> : <></>}
        </div>
        <Modal store={modalStore}>
            <div className="modal-card">
                <header className="modal-card-head">
                    <div className="modal-card-title">QR Code scannen zum identifizieren.</div>
                    <button className="delete" aria-label="close" onClick={() => {
                        modalStore.close()
                    }}></button>
                </header>
                <section className="modal-card-body p-3">
                    <div style={{display:'flex'}}>
                        <QRCode
                            size={256}
                            style={{height: "auto", maxWidth: "50%", width: "50%", margin: "auto"}}
                            value={dto.message}
                            viewBox={`0 0 256 256`}/>
                    </div>
                </section>
                <footer className="modal-card-foot" />
            </div>
        </Modal>
    </> : <></>}
    </>
}

const RegistrationNotificationBar = observer(function RegistrationNotificationBar() {
    const [showSingle, setShowSingle] = useState(true)

    if (!registrationNotificationStore.data || registrationNotificationStore.data.length === 0) {
        return <></>
    }

    if (registrationNotificationStore.data.length === 1) {
        return <RegistrationNotification dto={registrationNotificationStore.data[0]} />
    }
    const ActionButton = <button
        onClick={() => {
            setShowSingle(!showSingle)
        }}
        className={"button is-primary is-small"}>{showSingle ? 'Restliche Meldungen anzeigen' :'Restliche Meldungen ausblenden'}</button>
    if (showSingle) {
        return <RegistrationNotification dto={registrationNotificationStore.data[0]} ActionButton={() => ActionButton} />
    }

    return <>
        {registrationNotificationStore.data.map((e, index) => <RegistrationNotification
            dto={e}
            key={index}
            ActionButton={index === 0 ? () => ActionButton : undefined}
        />)}
    </>
})

export {
    RegistrationNotificationBar
}
